import { userReducer, userReducerName } from 'redux/slices/user/userSlice';
import {
  signUpReducer,
  signUpReducerName,
} from 'redux/slices/signUp/signUpSlice';
import {
  signUpApiReducer,
  signUpApiReducerName,
} from 'redux/slices/signUp/SignUpApi';
import {
  currentApiReducer,
  currentApiReducerName,
} from 'redux/slices/current/CurrentApi';
import { authReducer, authReducerName } from 'redux/slices/app/authSlice';
import {
  currentCreateReducer,
  currentCreateReducerName,
} from 'redux/slices/current/CurrentCreateSlice';
import {
  addressReducer,
  addressReducerName,
} from 'redux/slices/address/addressSlice';
import {
  addressApiReducer,
  addressApiReducerName,
} from 'redux/slices/address/addressApi';
import {
  shipmentApiReducer,
  shipmentApiReducerName,
} from 'redux/slices/shipments/shipmentApi';
import {
  reportTemplateReducer,
  reportTemplateReducerName,
} from './slices/reports/reportTemplateSlice';
import {
  shipmentReportApiReducer,
  shipmentReportApiReducerName,
} from './slices/reports/reportsApi';
import {
  shipmentCreateReducer,
  shipmentCreateReducerName,
} from './slices/shipments/shipmentSlice';
import { geoApiReducer, geoApiReducerName } from './slices/geo/geoApi';
import {
  createRoleSettingsReducer,
  createRoleSettingsReducerName,
} from './slices/role/createRoleSettingsSlice';
import { roleApiReducer, roleApiReducerName } from 'redux/slices/role/roleApi';
import {
  createRoleReducer,
  createRoleReducerName,
} from 'redux/slices/role/createRoleSlice';
import {
  createCurrencyReducer,
  createCurrencyReducerName,
} from 'redux/slices/currency/createCurrencySlice';
import {
  currencyApiReducer,
  currencyApiReducerName,
} from 'redux/slices/currency/currencyApi';
import {
  createBookServiceReducer,
  createBookServiceReducerName,
} from 'redux/slices/bookService/createBookServiceSlice';
import {
  bookServiceApiReducer,
  bookServiceApiReducerName,
} from 'redux/slices/bookService/bookServiceApi';
import {
  createServiceTypeReducer,
  createServiceTypeReducerName,
} from 'redux/slices/serviceType/createServiceTypeSlice';
import {
  serviceTypeApiReducer,
  serviceTypeApiReducerName,
} from 'redux/slices/serviceType/serviceTypeApi';
import {
  createDeliveryTypeReducer,
  createDeliveryTypeReducerName,
} from 'redux/slices/deliveryType/createDeliveryTypeSlice';
import {
  deliveryTypeApiReducer,
  deliveryTypeApiReducerName,
} from 'redux/slices/deliveryType/deliveryTypeApi';
import {
  createDocumentTypeReducer,
  createDocumentTypeReducerName,
} from 'redux/slices/documentType/createDocumentTypeSlice';
import {
  documentTypeApiReducer,
  documentTypeApiReducerName,
} from 'redux/slices/documentType/documentTypeApi';
import {
  createContainerTypeReducer,
  createContainerTypeReducerName,
} from 'redux/slices/containerType/createContainerTypeSlice';
import {
  containerTypeApiReducer,
  containerTypeApiReducerName,
} from 'redux/slices/containerType/containerTypeApi';
import {
  createStatusTypeReducer,
  createStatusTypeReducerName,
} from 'redux/slices/statusType/createStatusTypeSlice';
import {
  statusTypeApiReducer,
  statusTypeApiReducerName,
} from 'redux/slices/statusType/statusTypeApi';
import {
  definitionApiReducer,
  definitionApiReducerName,
} from './slices/definitions/userDefinitionApi';
import {
  userInfoReducer,
  userInfoReducerName,
} from './slices/profile/UserInfoSlice';
import {
  sideBarReducer,
  sideBarReducerName,
} from './slices/sideBar/sideBarSlice';
import {
  userInfoApiReducerName,
  userInfoApiReducer,
} from './slices/profile/userInfoApi';
import {
  createPermissionReducer,
  createPermissionReducerName,
} from './slices/permission/createPermissionSlice';
import {
  permissionApiReducer,
  permissionApiReducerName,
} from './slices/permission/permissionApi';
import {
  phoneCodeApiReducer,
  phoneCodeApiReducerName,
} from 'redux/slices/phoneCode/phoneCodeApi';
import {
  deliveryMethodApiReducer,
  deliveryMethodApiReducerName,
} from './slices/deliveryMethod/deliveryMethodApi';
import {
  snackbarReducer,
  snackbarReducerName,
} from './slices/snackbar/snackbarSlice';
import {
  shipmentTrackingReducer,
  shipmentTrackingReducerName,
} from './slices/shipment-tracking/ShipmentTrackingApi';
import {
  shipmentTrackingSliceReducer,
  shipmentTrackingSliceReducerName,
} from './slices/shipment-tracking/ShipmentTrackingSlice';
import {
  gtipApiReducer,
  gtipApiReducerName,
} from './slices/gtip/gtipApi';
import {
  createPricesReducer,
  createPricesReducerName,
} from 'redux/slices/prices/createPricesSlice';
import {
  pricesApiReducer,
  pricesApiReducerName,
} from 'redux/slices/prices/pricesApi';

const rootReducer = {
  [userReducerName]: userReducer,
  [addressApiReducerName]: addressApiReducer,
  [shipmentApiReducerName]: shipmentApiReducer,
  [currentApiReducerName]: currentApiReducer,
  [signUpReducerName]: signUpReducer,
  [authReducerName]: authReducer,
  [signUpApiReducerName]: signUpApiReducer,
  [currentCreateReducerName]: currentCreateReducer,
  [addressReducerName]: addressReducer,
  [reportTemplateReducerName]: reportTemplateReducer,
  [shipmentReportApiReducerName]: shipmentReportApiReducer,
  [shipmentCreateReducerName]: shipmentCreateReducer,
  [geoApiReducerName]: geoApiReducer,
  [createCurrencyReducerName]: createCurrencyReducer,
  [currencyApiReducerName]: currencyApiReducer,
  [createBookServiceReducerName]: createBookServiceReducer,
  [bookServiceApiReducerName]: bookServiceApiReducer,
  [createServiceTypeReducerName]: createServiceTypeReducer,
  [serviceTypeApiReducerName]: serviceTypeApiReducer,
  [snackbarReducerName]: snackbarReducer,
  [createDocumentTypeReducerName]: createDocumentTypeReducer,
  [documentTypeApiReducerName]: documentTypeApiReducer,
  [shipmentTrackingReducerName]: shipmentTrackingReducer,
  [containerTypeApiReducerName]: containerTypeApiReducer,
  [createContainerTypeReducerName]: createContainerTypeReducer,
  [createStatusTypeReducerName]: createStatusTypeReducer,
  [statusTypeApiReducerName]: statusTypeApiReducer,
  [createDeliveryTypeReducerName]: createDeliveryTypeReducer,
  [deliveryTypeApiReducerName]: deliveryTypeApiReducer,
  [deliveryMethodApiReducerName]: deliveryMethodApiReducer,
  [roleApiReducerName]: roleApiReducer,
  [createRoleReducerName]: createRoleReducer,
  [createRoleSettingsReducerName]: createRoleSettingsReducer,
  [definitionApiReducerName]: definitionApiReducer,
  [userInfoReducerName]: userInfoReducer,
  [userInfoApiReducerName]: userInfoApiReducer,
  [permissionApiReducerName]: permissionApiReducer,
  [createPermissionReducerName]: createPermissionReducer,
  [phoneCodeApiReducerName]: phoneCodeApiReducer,
  [sideBarReducerName]: sideBarReducer,
  [shipmentTrackingSliceReducerName]: shipmentTrackingSliceReducer,
  [gtipApiReducerName]: gtipApiReducer,
  [createPricesReducerName]: createPricesReducer,
  [pricesApiReducerName]: pricesApiReducer,
};

export default rootReducer;
